/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { constantMapper, entity, enumeration, enumMap, identity } from '@gh/core-data';
import {
  UserAllowAccess,
  UserAssignedRoleDto,
  UserDetailsDto,
  UserDetailsFilterDto,
  UserDetailsIntranetDto,
  UserDetailsVerifyDto,
} from './user-details.dto';
import { UserStatus } from './user-status.enum';
import { UserSystemRole } from './user-system-role.enum';

export const UserDetailsMapper = entity<UserDetailsDto>({
  status: enumeration(UserStatus),
  systemRoles: enumMap(UserSystemRole, identity()),
  allowAccessToLeads: enumeration(UserAllowAccess),
});

export const UserSystemRoleMapper = enumMap(UserSystemRole, identity());

export const UserDetailsFilterMapper = entity<UserDetailsFilterDto>();

export const UserAssignedRoleMapper = entity<UserAssignedRoleDto>({});

export const UserDetailsVerifyMapper = entity<UserDetailsVerifyDto>({});
export const UserDetailsIntranetMapper = entity<UserDetailsIntranetDto>({});

export const UserSystemRoleIntMapper = constantMapper({
  1: UserSystemRole.Corporate,
  2: UserSystemRole.Master,
  3: UserSystemRole.Franchisee,
  4: UserSystemRole.Estimator,
  5: UserSystemRole.Supervisor,
  6: UserSystemRole.JobAdmin,
  7: UserSystemRole.Accountant,
  8: UserSystemRole.Salesperson,
});
